import React from 'react';
import _ from 'lodash';
import {Box, Container, Divider, Stack, Typography, useMediaQuery,
  useTheme} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {useQuery} from '@tanstack/react-query';
import {useQueryParam} from '../util/react_hooks.js';
import api from '../util/api.js';
import TarotSpreadComp from '../components/TarotSpreadComp.js';
import SCButton from '../components/SCButton.js';
import HtmlContent from '../components/HtmlContent.js';
import {useLoaderState} from '../components/Loader.js';

const ExternalAnswerComp = props=>{
    let {card, question} = props;
    let {data, isLoading} = useQuery({
        queryKey: ['getCard', card],
        queryFn: ()=>api.getCard(card),
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        cacheTime: 0,
        gcTime: 0,
    });
    useLoaderState(isLoading);
    let theme = useTheme();
    let md = useMediaQuery(theme.breakpoints.down('md'));
    if (!data)
        return null;
    return <Stack direction="column" gap={3} alignItems="center"
      marginTop={5} marginBottom={5}>
      {question&&<>
        <Typography variant="h5">
          מסר בנושא: "{question}"
        </Typography>
        <Divider sx={{width: '100%'}}/>
      </>}
      <Typography variant="h3">
        {data.title}
      </Typography>
      <Typography variant="h6">
        {data.subtitle}
      </Typography>
      <Stack direction={md ? 'column' : 'row'} gap={3}>
        <Box component="img" src={data.image}
          sx={{objectFit: 'contain', maxHeight: '500px'}}/>
        <Stack direction="column" gap={3} alignItems="start">
            <HtmlContent content={data.content}/>
        </Stack>
      </Stack>
    </Stack>;
};

const TarotSpread = ()=>{
    let [backLink] = useQueryParam('back_link');
    let [backText] = useQueryParam('back_text');
    let [redirectLink] = useQueryParam('redirect_link');
    let [answerCard] = useQueryParam('answer_card');
    let [qsQuestion] = useQueryParam('question');
    if (answerCard)
    {
        return <Container maxWidth="lg">
          <ExternalAnswerComp card={answerCard} question={qsQuestion}/>
        </Container>;
    }
    return <Container maxWidth="lg">
      {backLink&&<SCButton text={backText||'חזרה'} variant="text"
        icon={<ChevronRightIcon/>} onClick={()=>window.open(backLink, '_self')}/>}
      <TarotSpreadComp redirectLink={redirectLink} answerCard={answerCard}/>
    </Container>;
};

export default TarotSpread;
